import { ProgrammeThemeDto } from '@ecdlink/core';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { ContentProgrammeThemeService } from '@services/ContentProgrammeThemeService';
import { RootState, ThunkApiType } from '../../types';

export const ProgrammeThemeActions = {
  GET_PROGRAMME_THEMES: 'getProgrammeThemes',
};

export const getProgrammeThemes = createAsyncThunk<
  ProgrammeThemeDto[],
  { locale: string; overrideCache?: boolean },
  ThunkApiType<RootState>
>(
  ProgrammeThemeActions.GET_PROGRAMME_THEMES,
  async ({ locale, overrideCache = false }, { getState, rejectWithValue }) => {
    const {
      auth: { userAuth },
      programmeThemeData: { programmeThemes: programmeThemeCache },
    } = getState();

    // === CACHE CHECK ===
    if (
      !overrideCache &&
      programmeThemeCache &&
      programmeThemeCache.length > 0
    ) {
      return programmeThemeCache;
    }

    // === FETCH FROM API ===
    try {
      if (!userAuth?.auth_token) {
        return rejectWithValue('no access token, profile check required');
      }

      return await new ContentProgrammeThemeService(
        userAuth?.auth_token
      ).getProgrammeThemes(locale);
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
